import { Position } from "../helpers";

export const CITY_OPTIONS: CityOption[] = [
  {
    value: "pittsburgh",
    label: "Pittsburgh, PA",
    lat: 40.440624,
    long: -79.995888,
    payeeAccountId: process.env.REACT_APP_PITTSBURGH_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Pittsburgh",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/pittsburgh/logox72`,
  },
  {
    value: "bethlehem",
    label: "Bethlehem, PA",
    lat: 40.62638821134342,
    long: -75.37046807878374,
    payeeAccountId: process.env.REACT_APP_BETHLEHEM_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Bethlehem",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/bethlehem/logox88.png`,
  },
  {
    value: "fortlee",
    label: "Fort Lee, NJ",
    lat: 40.851959,
    long: -73.96893,
    payeeAccountId: process.env.REACT_APP_FORT_LEE_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Fort Lee",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/fort-lee/logo.svg`,
  },
  {
    value: "gsp-airport",
    label: "GSP Airport",
    lat: 34.89573152197923,
    long: -82.21683194682056,
    payeeAccountId: process.env.REACT_APP_GSP_AIRPORT_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "GSP Airport",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/gsp-airport/logo.png`,
  },
  {
    value: "houston",
    label: "Houston, TX",
    lat: 29.7604,
    long: -95.3698,
    payeeAccountId: process.env.REACT_APP_HOUSTON_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Houston",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/houston/logox88.png`,
    sealImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/houston/sealx88.png`,
  },
  {
    value: "philly",
    label: "Philadelphia, PA",
    long: -75.1652,
    lat: 39.9526,
    payeeAccountId: process.env.REACT_APP_PHIL_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Philadelphia",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/phil/logo.png`,
  },
  {
    value: "miami",
    label: "Miami, FL",
    long: -80.19270471728056,
    lat: 25.772516997858347,
    payeeAccountId: process.env.REACT_APP_MPA_ACCOUNT_ID || "",
    allowUserSelection: true,
    landingPageLabel: "Miami",
    logoImageUrl: `${process.env.REACT_APP_ASSET_ENDPOINT}/images/miami/logo.png`,
  },
];

export interface CityOption extends Position {
  value: string;
  label: string;
  payeeAccountId: string;
  /** Determines if the user can select this city/location. */
  allowUserSelection: boolean;
  /** Label displayed for landing page text */
  landingPageLabel: string;
  /** URL to the logo image  */
  logoImageUrl: string;
  /** URL to the seal image  */
  sealImageUrl?: string;
}

export const GSP_TOS_VERSION = "GSP-2026-06-01";

export const phoneNumberRegex =
  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
export type AppName = "app.automotus.io" | "curbpass.io" | "curbsuite.io";

export const appName: AppName = (process.env.REACT_APP_APP_NAME || "").includes("automotus.io")
  ? "app.automotus.io"
  : (process.env.REACT_APP_APP_NAME || "").includes("curbsuite.io")
  ? "curbsuite.io"
  : "curbpass.io";
